// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-upload .ant-modal-content {
  height: 85vh;
  overflow: scroll;
}
.bulk-upload .ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.bulk-upload-header {
  font-family: Montserrat;
  color: #000;
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.steps {
  font-family: Roboto;
  color: #000;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-top: 32px;
  margin-bottom: 10px;
}
.download-btn,
.download-btn:hover {
  font-family: Roboto;
  display: inline-flex;
  height: 50px;
  padding: 8px 26px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #2b1010 !important;
  background: #f5f5f5;
  color: var(--Colors-Text-500, #0a0f0d) !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.uploaded-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1.375rem;
}
.uploaded-section .file-name {
  font-family: Roboto;
  color: #000;
  font-size: var(--Font-Font-Size-p, 1rem);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.uploaded-section .file-details {
  margin: 0 16px 19px 19px;
}
.size-text {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.uploaded-text {
  color: var(--Colors-Secondary-500, #008342);
  font-size: var(--Font-Font-Size-small, 0.8125rem);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.error-header {
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 19.5px;
}
.dragger {
  width: 578px;
  height: 30vh;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px dashed #c9c9c9;
  background: #fcfcfc;
  margin-top: 28px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
.drag-drop-text {
  color: #717171 !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 14px;
}
.drag-drop {
  font-size: 16px;
}
.or {
  font-size: 13px;
}
.browse-btn {
  border-radius: 3px;
  background: var(--Colors-Primary-500, #d2042d) !important;
  width: 119px;
  height: 40px;
  padding: 8px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: #fff !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.browse-section {
  display: flex;
  justify-content: center;
}
.bg-help-text {
  color: var(--Colors-Primary-500, #d2042d);
  background: rgba(210, 4, 45, 0.1);
  justify-content: center;
}
.help-text {
  flex-direction: column;
  display: flex;
  width: 578px;
  height: auto;
  overflow-y: scroll;
  padding: 8px;
  gap: 8px;
  flex-shrink: 0;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 3px;
  margin-top: 14px;
}

.upload-btn {
  background: var(--Colors-Primary-500, #d2042d) !important;
  color: #fff !important;
  border: none;
  opacity: 0.5;
}

.cancel-btn {
  background: #f0f0f0 !important;
  color: #0a0f0d !important;
  margin-right: 1rem;
  border: none;
}
.footer-btns {
  font-family: Roboto;
  border-radius: 3px;
  display: flex;
  height: 40px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.product-select {
  display: flex;
  height: 50px;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);
  background: #fcfcfc;
}
.dragger .ant-upload {
  border: none;
  background: #fff;
}

.browse-button {
  font-family: Roboto;
  display: flex;
  width: 7.4375rem;
  height: 2.5rem;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 3px;
  background: var(--Colors-Primary-500, #d2042d);
  color: #fff;
  justify-self: center;
}
.enable-btn {
  opacity: 1;
}
@media (max-width: 768px) {
  .dragger,
  .help-text {
    width: auto;
  }
  .download-btn {
    width: 42vw;
    margin-left: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/SellerFlow/modals/bulk-upload/BulkUploadModal.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,iDAAiD;EACjD,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wDAAwD;EACxD,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE;;IAEE,WAAW;EACb;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":[".bulk-upload .ant-modal-content {\n  height: 85vh;\n  overflow: scroll;\n}\n.bulk-upload .ant-modal-mask {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n\n.bulk-upload-header {\n  font-family: Montserrat;\n  color: #000;\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n}\n.steps {\n  font-family: Roboto;\n  color: #000;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  margin-top: 32px;\n  margin-bottom: 10px;\n}\n.download-btn,\n.download-btn:hover {\n  font-family: Roboto;\n  display: inline-flex;\n  height: 50px;\n  padding: 8px 26px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border: 1px solid #2b1010 !important;\n  background: #f5f5f5;\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.uploaded-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1.375rem;\n}\n.uploaded-section .file-name {\n  font-family: Roboto;\n  color: #000;\n  font-size: var(--Font-Font-Size-p, 1rem);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.uploaded-section .file-details {\n  margin: 0 16px 19px 19px;\n}\n.size-text {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.uploaded-text {\n  color: var(--Colors-Secondary-500, #008342);\n  font-size: var(--Font-Font-Size-small, 0.8125rem);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.error-header {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 19.5px;\n}\n.dragger {\n  width: 578px;\n  height: 30vh;\n  flex-shrink: 0;\n  border-radius: 10px;\n  border: 1px dashed #c9c9c9;\n  background: #fcfcfc;\n  margin-top: 28px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n}\n.drag-drop-text {\n  color: #717171 !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-bottom: 14px;\n}\n.drag-drop {\n  font-size: 16px;\n}\n.or {\n  font-size: 13px;\n}\n.browse-btn {\n  border-radius: 3px;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  width: 119px;\n  height: 40px;\n  padding: 8px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  color: #fff !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.browse-section {\n  display: flex;\n  justify-content: center;\n}\n.bg-help-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  background: rgba(210, 4, 45, 0.1);\n  justify-content: center;\n}\n.help-text {\n  flex-direction: column;\n  display: flex;\n  width: 578px;\n  height: auto;\n  overflow-y: scroll;\n  padding: 8px;\n  gap: 8px;\n  flex-shrink: 0;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  border-radius: 3px;\n  margin-top: 14px;\n}\n\n.upload-btn {\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  color: #fff !important;\n  border: none;\n  opacity: 0.5;\n}\n\n.cancel-btn {\n  background: #f0f0f0 !important;\n  color: #0a0f0d !important;\n  margin-right: 1rem;\n  border: none;\n}\n.footer-btns {\n  font-family: Roboto;\n  border-radius: 3px;\n  display: flex;\n  height: 40px;\n  padding: 8px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.product-select {\n  display: flex;\n  height: 50px;\n  padding: 10px 20px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);\n  background: #fcfcfc;\n}\n.dragger .ant-upload {\n  border: none;\n  background: #fff;\n}\n\n.browse-button {\n  font-family: Roboto;\n  display: flex;\n  width: 7.4375rem;\n  height: 2.5rem;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  background: var(--Colors-Primary-500, #d2042d);\n  color: #fff;\n  justify-self: center;\n}\n.enable-btn {\n  opacity: 1;\n}\n@media (max-width: 768px) {\n  .dragger,\n  .help-text {\n    width: auto;\n  }\n  .download-btn {\n    width: 42vw;\n    margin-left: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
